import { Alert, Typography } from "@mui/material";

export const ValidationErrors = ({ errors }) => {
  return (
    <>
      <Alert severity="error" sx={{ my: 2 }}>
        <Typography variant="subtitle1">
          Credit check couldn't be generated due to Validation Errors. See
          detail below:
        </Typography>
      </Alert>

      {!Array.isArray(errors) && <Alert severity="error">{errors}</Alert>}

      {Array.isArray(errors) &&
        errors.map(({ code, expected, message, path }) => (
          <Alert severity="error" sx={{ my: 2 }}>
            <Typography variant="subtitle2">
              {code} (Expected: {expected})
            </Typography>
            <Typography variant="p">Field: {path}</Typography>
            <br />
            <Typography variant="p">Message: {message}</Typography>
          </Alert>
        ))}
    </>
  );
};
